<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <app-modal-back
        icon="close"
        ariaLabel="close"
      ></app-modal-back>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container *ngIf="form">
    <div class="mable-section ion-padding-top">
      <mable-heading
        heading="h2"
        headingStyle="h1"
      >
        {{assessmentService.assessmentData?.isFirstWeekly ? 'First' : 'Second'}} week evaluation
      </mable-heading>
      <div class="description content ion-margin-horizontal">
        <ion-icon
          aria-hidden="true"
          name="calendar"
        ></ion-icon>
        <ion-label class="body-semi-bold">
          For {{assessmentService.assessmentData?.agreement?.otherUser?.firstName}},
          {{assessmentService.assessmentData?.periodStartDate | date :'d MMMM'}} to
          {{assessmentService.assessmentData?.periodEndDate | date :'d MMMM'}}
        </ion-label>
      </div>
      <div
        class="sub-section"
        *ngIf="assessmentValue.scheduledSessions === assessmentValue.noShows"
      >
        <p class="ion-margin-horizontal">
          We're sorry to hear that {{assessmentService.assessmentData?.agreement?.otherUser?.firstName}} didn't show up
          to your scheduled sessions.
        </p>
      </div>
    </div>
    <form [formGroup]="form">
      <mable-input
        label="Did {{assessmentService.assessmentData?.agreement?.otherUser?.firstName}} turn up on time for all {{assessmentValue?.scheduledSessions}} sessions?"
        [noBorder]="true"
        *ngIf="assessmentValue.scheduledSessions !== assessmentValue.noShows"
      >
        <mb-radio-group
          [options]="radioGroupOptions"
          radioStyle="default-grid"
          formControlName="isOnTime"
          class="small-radio-buttons"
        >
        </mb-radio-group>
      </mable-input>

      <mable-input
        label="How many sessions did they arrive late without notice or acceptable reason?"
        [noBorder]="true"
        *ngIf="!form.value.isOnTime && assessmentValue.scheduledSessions !== assessmentValue.noShows"
      >
        <mb-radio-group
          [options]="lateOrNoSessions"
          radioStyle="oval-grid"
          formControlName="lateArrivals"
          class="small-oval-radio-buttons"
        >
        </mb-radio-group>
      </mable-input>

      <mable-input
        label="How many sessions were agreed tasks not completed as expected?"
        [noBorder]="true"
        *ngIf="assessmentValue.scheduledSessions !== assessmentValue.noShows"
      >
        <mb-radio-group
          [options]="lateOrNoSessions"
          radioStyle="oval-grid"
          formControlName="incompleteTasks"
          class="small-oval-radio-buttons"
        >
        </mb-radio-group>
      </mable-input>

      <mable-input label="Any other feedback? (optional)">
        <ion-textarea
          autocapitalize="sentences"
          rows="4"
          formControlName="otherFeedback"
        >
        </ion-textarea>
      </mable-input>
    </form>
  </ng-container>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <mable-button
          category="outline"
          expand="block"
          (onClick)="modalCtrl.dismiss();"
        >
          Back
        </mable-button>
      </ion-col>
      <ion-col>
        <mable-button
          expand="block"
          (onClick)="Submit()"
        >
          Submit
        </mable-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
